import React from 'react'
import LoginForm from './Login'
import { Navigate } from "react-router-dom";
import { Link } from "react-router-dom";
import { LoginMain } from '../../../styles/common.style';

const Login = () => {
  // TODO: Remove this line
  let user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : null

  if (user) {
    return <Navigate to="/welcome" replace />;
  }
  return (
    <LoginMain>
      <div className='login-main-block'>
        <div className='login-main-block-left'>
          <div className='login-main-block-left-link'>
            <Link to='/'>
              <img src='/images/logo-auth-2.png' alt='img' />
            </Link>
          </div>
          <div className='login-main-block-left-banner'>
            <img src='/images/login-banner.png' alt='login-banner' />
          </div>
          <div className='title-block'>
            <h1>Welcome</h1>
          </div>
        </div>
        <div className='login-main-block-right'>
          <LoginForm />
        </div>
      </div>
    </LoginMain>
  );
}

export default Login